import { FormBuilder } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';

export class SocialPlanDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
